var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { ToggleButtonGroup as MuiToggleButtons, ToggleButton as MuiToggleButton } from '@mui/material';
import cls from 'classnames';
import useFormatOptions from '../../hooks/useFormatOptions';
import Text from '../Text';
import { useCallback, useEffect, useState } from 'react';
var Flex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 12px;\n"], ["\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 12px;\n"])));
// TODO(jenky): Might allow multiple values
export default function ToggleButtons(props) {
    var defaultValue = props.defaultValue, onChange = props.onChange, options = props.options, hasToggleBar = props.hasToggleBar, _a = props.allowUnselect, allowUnselect = _a === void 0 ? false : _a, _b = props.hasNewTheme, hasNewTheme = _b === void 0 ? false : _b;
    var formattedOptions = useFormatOptions(options);
    var _c = useState(defaultValue), value = _c[0], setValue = _c[1];
    var onToggleChange = useCallback(function (e, newValue) {
        if (allowUnselect) {
            setValue(newValue);
        }
        else if (newValue !== null && newValue !== value) {
            setValue(newValue);
        }
    }, [value]);
    useEffect(function () {
        onChange(value);
    }, [onChange, value]);
    var defaultTextColors = function (optionValue) { return (optionValue === value ? 'neutral100' : 'neutral80'); };
    var newThemeTextColors = function (optionValue) { return (optionValue === value ? 'proximaGreen20' : 'neutral70'); };
    var classes = cls({
        'new-toggle-button-theme': hasNewTheme,
        'toggle-bar-theme': hasToggleBar,
        'toggle-button-theme-legacy': true
    });
    return (_jsx(MuiToggleButtons, __assign({ exclusive: true, value: value, onChange: onToggleChange, className: classes }, { children: formattedOptions.map(function (option) { return (_jsx(MuiToggleButton, __assign({ color: "primary", disableRipple: true, value: option.value, className: classes }, { children: _jsxs(Flex, { children: [option.icon, _jsx(Text, __assign({ color: hasNewTheme ? newThemeTextColors(option.value) : defaultTextColors(option.value), variant: hasNewTheme ? 'body2Semibold' : 'body2' }, { children: option.label }))] }) }), option.value)); }) })));
}
var templateObject_1;
